module.exports = __webpack_public_path__ + "/static/assets/c4a19235946c75e2c81af81e843e8342.gif";